export default {
  props: {
    error: { type: Object, required: true },
    name: { type: String, required: true }
  },
  watch: {
    error () {
      const focused = this.error && this.name && this.error.fieldId === this.name
      if (focused) {
        // console.log(this.$refs, this.name, this.$refs[this.name])
        this.$refs[this.name].focus()
      }
    }
  }
}
